export enum DriverEventType {
    DriverDepartedToPickup = 'DRIVER_DEPARTED_TO_PICKUP',
    DriverArrivedAtPickup = 'DRIVER_ARRIVED_AT_PICKUP',
    DriverDepartedToDropoff = 'DRIVER_DEPARTED_TO_DROPOFF',
    DriverArrivedAtDropoff = 'DRIVER_ARRIVED_AT_DROPOFF',
    DriverSubmittedCustomerNoShow = 'DRIVER_SUBMITTED_CUSTOMER_NO_SHOW',
}
